import { Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material/icon';

@Injectable({
  providedIn: 'root',
})
export class IconsService {
  constructor(
    private _domSanitizer: DomSanitizer,
    private _matIconRegistry: MatIconRegistry,
  ) {
    this._matIconRegistry.addSvgIconSetInNamespace(
      'mat_outline',
      this._domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/material-outline.svg'),
    );

    // Không còn 'mat_solid': sprite material-solid.svg nặng 670.251 B với 1.792 symbol mà
    // KHÔNG có lấy một lần dùng nào trong toàn bộ mã nguồn — nó chỉ còn được nhắc tới trong
    // chính dòng đăng ký này. Đã xoá cả file lẫn đăng ký (2026-08-02).

    this._matIconRegistry.addSvgIconSetInNamespace(
      'design',
      this._domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/design.svg'),
    );

    // Carot "Quản lý bán hàng" sidebar icon set (stroke SVGs from the design).
    this._matIconRegistry.addSvgIconSetInNamespace(
      'sales',
      this._domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/sales.svg'),
    );
  }
}
